import { ccmPageActionAllowedStatues } from 'constants/patient_statuses';

export const isPatient = (userType) => userType === 'patient';
export const isPractice = (userType) => userType === 'practice';
export const isAdmin = (userType) => userType === 'admin';
export const isAgencyDoctor = (userType) => userType === 'homeHealth';
export const isRoleNameAdministrator = (roleNames) =>
  roleNames.includes('administrator');
export const isRoleNameAdminTools = (rolesNames) =>
  rolesNames.includes('adminTools');
export const isOnboardingPatient = (onboardingStatuses, status) =>
  onboardingStatuses.includes(status);
export const isCcmAgencyDoctor = (userType, roleNames) =>
  userType === 'homeHealth' &&
  roleNames.some((roleName) => roleName.startsWith('ccm-'));
export const agencyDoctorWithRPMAndCCMRoles = (userType, roleNames) =>
  userType === 'homeHealth' &&
  roleNames.some(
    (roleName) =>
      !roleName.includes('ccm-') && !roleName.includes('administrator'),
  ) &&
  roleNames.some((roleName) => roleName.includes('ccm-'));
export const isBiller = (roleNames) =>
  roleNames?.every(
    (roleName) => roleName === 'biller' || roleName === 'ccm-biller',
  );
export const isPatientAcceptance = (roleNames) =>
  roleNames.includes('patientAcceptance');
export const isCcmActionAllowedStatus = (ccmStatus) =>
  ccmPageActionAllowedStatues.includes(ccmStatus);
